export default __webpack_public_path__ + "static/media/ielts-6-thumb.d1121cf7.jpg";